/** @file checkHinted: a field check whose failures carry a hint naming the field's range and meaning. */
import { throwError } from '@zilo/pose3d-std/errors/throwError';
import { toPose3DError } from '@zilo/pose3d-std/errors/toPose3DError';
import type { FieldCheck } from '@zilo/pose3d-format/validate/fields/fieldCheck';

/** `check`, re-throwing a hint-less failure with `hint` (a failure that already has a hint keeps it). */
export function checkHinted(check: FieldCheck, hint: string): FieldCheck {
  return (value, path) => {
    try {
      check(value, path);
    } catch (e) {
      const err = toPose3DError(e);
      if (err === null || err.hint !== undefined) throw e;
      throwError(err.code, { ...err.params }, err.path === undefined ? { hint } : { path: err.path, hint });
    }
  };
}
